import { render, staticRenderFns } from "./CardLoading.vue?vue&type=template&id=0489b9b0&scoped=true"
import script from "./CardLoading.vue?vue&type=script&lang=js"
export * from "./CardLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489b9b0",
  null
  
)

export default component.exports